import * as React from 'react';
import { forwardRef } from 'react';
import { Then } from 'react-if';
import cns from 'classnames';
import { useTranslation } from 'next-i18next';
import { match } from 'ts-pattern';
import { TrashIcon, UploadIcon } from '@zep/icons';
import { CircularProgress, IconContainer } from '@zep/ui';
import { Colors } from '@zep/ui-tokens';
import S from './InputImage.module.scss';
export const InputImage = forwardRef<HTMLInputElement, InputImageProps>((props: InputImageProps, ref) => {
  const {
    imageSrc = '',
    acceptType,
    name,
    helperText,
    isLoading = false,
    isDisabled = false,
    onUploadImage,
    clearImage
  } = props;
  const {
    t
  } = useTranslation(['accounts']);
  const accept = acceptType.map(d => `.${d}`).join(',');
  const handleClickTrashIcon = (e: React.MouseEvent) => {
    e.preventDefault();
    clearImage(name);
  };
  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    onUploadImage(e.currentTarget.name, e.currentTarget.files);
  };
  const status = isLoading ? 'loadingImage' : imageSrc ? 'onImage' : 'noneImage';
  return <div className={S.container}>
        <label className={cns(S.label, imageSrc && S.is_image, isDisabled && S.disabled)}>
          <input ref={ref} type="file" hidden accept={accept} src={imageSrc} onChange={handleOnChange} name={name} disabled={isDisabled} />
          {match(status).with('loadingImage', () => <Then>
                <div className={S.indicator}>
                  <CircularProgress size={32} color={Colors.Gray400} />
                </div>
              </Then>).with('onImage', () => <>
                <img src={imageSrc} className={S.image} alt="image" />
                <IconContainer className={S.button} onClick={handleClickTrashIcon}>
                  <TrashIcon width={16} height={16} />
                </IconContainer>
              </>).otherwise(() => <></>)}
          <div className={S.empty}>
            <UploadIcon />
            <span className="text-caption-2">
              {t('accounts:myApp.upload.imageEmptyLabel')}
            </span>
          </div>
        </label>
        <p className={'text-caption-1'}>{helperText}</p>
      </div>;
});
InputImage.displayName = 'InputImage';
type ImagFileExtension = 'gif' | 'jpg' | 'jpeg' | 'png' | 'svg' | 'webp';
type InputImageProps = {
  name: string;
  imageSrc: string;
  helperText?: string;
  acceptType: ImagFileExtension[];
  isLoading?: boolean;
  isDisabled?: boolean;
  clearImage: (name: string) => void;
  onUploadImage: (type: string, files: FileList | null) => void;
};